import breakpoint from './breakpoint';
import init from './jquery.init';
import validity from './jquery.validity';
import './jquery.transitionDuration';
import 'select2/dist/js/select2.full.js';
import './init/dataIf';
import $ from 'jquery';
import { showModal } from '../components/b-modal';

window.jQuery = window.$ = $;

$.showModal = showModal;

function updateScrollbarWidth() {
	var root = document.documentElement;
	root.style.setProperty('--window-scrollbar-width', (window.innerWidth - root.clientWidth) + 'px');
}
window.addEventListener('resize', updateScrollbarWidth);
$(updateScrollbarWidth);
